import React from "react";
import "./LetterToYou.css";

const LetterToYou: React.FC = () => {
  return (
    <section id="letter" className="letter-section">
      <div className="letter-container">
        {/* <h2 className="section-heading">Dear You,</h2> */}
        <div className="letter-content">
          <p className="letter-text">Dear You,</p>
          <p className="letter-text">
            If you’re reading this, perhaps a part of you is considering taking
            care of yourself and starting therapy and yet, it’s completely
            natural to feel unsure, hesitant, or even overwhelmed by the idea of
            taking the first step.
          </p>
          <p className="letter-text">
            You don’t need to have everything figured out before starting
            therapy. This is simply a space for you to sit with someone who will
            hold space for you, listen without any judgement, and walk alongside
            you as you make sense of whatever it is that you’re feeling.
          </p>
          <p className="letter-text">
            “What will I talk about?”, “Where do I begin?”, “What will the
            process look like?”, “How will I explain what I am feeling?” are
            common questions to have. Don’t let these questions hold you back.
            We will navigate these questions together, one step at a time.
          </p>
          <p className="letter-text">
            Whether you’re navigating life’s challenges, exploring personal
            growth or just sensing that you need space to breathe and reflect,
            I’m here to hold a safe and gentle space for you.
          </p>
          <p className="letter-text">
            Healing is a journey and I would be honored to join you on yours.
          </p>
          <p className="letter-signature">
            With warmth and hope,
            <br />
            Your therapist, <br />
            Arushi Suri
          </p>
        </div>
      </div>
    </section>
  );
};

export default LetterToYou;
